// @owners { team: patient-fulfillment }
// TODO: move transfers out of the prescriptions reducer
import { type ReduxStateShared } from '~shared/types';

export default (state: ReduxStateShared) => state.prescriptions.transfers;
export const getLastRequestAttemptedAt = (state: ReduxStateShared) =>
  state.prescriptions.lastTransfersRequestAttemptedAt;
export const getRequestAttemptCount = (state: ReduxStateShared) => state.prescriptions.transfersRequestAttemptCount;
export const getLastRequestSucceededAt = (state: ReduxStateShared) =>
  state.prescriptions.lastTransfersRequestSucceededAt;
